/* eslint-disable camelcase */
import {
  Button, Spinner,
} from 'react-bootstrap';
import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faInfoCircle, faTrashAlt, faSync,
} from '@fortawesome/free-solid-svg-icons';
import './VMNSOverview.css';
import { sess_delete, sess_get, sess_put } from '../../../utils/HttpRequests';
import { OperationModal } from '../common';
import Pagination from '../Pagination';

const VMNSOverview = () => {
  const [formData, setFormData] = useState({
    search_category1: '', search_category2: '', search_text: '', allotment_status: '',
  });
  const [vmnToDelete, setVMNToDelete] = useState('');
  const [vmnToMovetoAvailable, setVMNToMovetoAvailable] = useState('');

  const [detail, setDetail] = useState({
    available_count: 0,
    default_count: 0,
    premium_count: 0,
    reserved_count: 0,
    totalVmnsTableCount: 0,
    total_count: 0,
    used_count: 0,
    vip_count: 0,
    vmns: [],
  });
  const [isLoading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [error, setError] = useState('');
  const [pageSize, setPageSize] = useState(100);
  const [pageNo, setPageNumber] = useState(1);
  const [showStatsModal, setStatsShowModal] = useState(false);
  const [showMoveToAvailableModal, setMoveToAvailableModal] = useState(false);

  const getAllVMNS = async () => {
    try {
      setLoading(true);
      let url = `admin/console/vmns?pageNo=${pageNo}&pageSize=${pageSize}`;
      Object.keys(formData).forEach((key) => {
        if (formData[key]) {
          url = `${url}&${key}=${formData[key]}`;
        }
      });

      const sessionToken = localStorage.getItem('admin-panel-sessionToken');
      const res = await sess_get(url, sessionToken);
      setDetail({ ...detail, ...res?.data?.response });
      setLoading(false);
      setPageSize(100);
    } catch (err) {
      setLoading(false);
      setError(err.message);
    }
  };

  useEffect(() => {
    getAllVMNS();
  }, [pageNo]);

  const onChange = (e) => {
    setError('');
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const deleteVMN = async () => {
    try {
      setError('');
      setLoading(true);
      const sessionToken = localStorage.getItem('admin-panel-sessionToken');
      await sess_delete('admin/console/vmn', sessionToken, { id: vmnToDelete._id });
      setError('Deleted Successfully');
      // setTimeout(() => setError(''), 2000);
      setShowModal(false);
      getAllVMNS();
    } catch (err) {
      setLoading(false);
      setError(err?.response?.data?.error?.reason || err.message || 'something went wrong in delete vmn');
    }
  };

  const Spin = () => (<Spinner style={ { margin: 'auto 50%' } } animation="border" />);

  const moveToAvailable = async () => {
    try {
      setError('');
      setLoading(true);
      const sessionToken = localStorage.getItem('admin-panel-sessionToken');
      await sess_put('admin/console/vmn/move-to-available', sessionToken, { id: vmnToMovetoAvailable._id });
      setError('Moved Successfully');
      setMoveToAvailableModal(false);
      getAllVMNS();
    } catch (err) {
      setLoading(false);
      setError(err?.response?.data?.error?.reason || err.message || 'something went wrong in delete vmn');
    }
  };

  const vmnsHTML = detail.vmns.map((vmn) => (
    <>
      <tr>
        <td title={ vmn.v_mobile_no }>{ vmn.v_mobile_no || '-' }</td>
        <td title={ vmn.price }>{ vmn.price / 100 || '0' }</td>
        <td title={ vmn.is_used }>
          { vmn.is_used ? 'Yes' : 'No' }
          <span uib-tooltip="Reserved">
            { vmn.is_reserved ? '***' : '' }
          </span>
        </td>
        <td title={ vmn.is_premium }>{ vmn.is_premium ? 'Yes' : 'No' }</td>
        <td title={ vmn.is_vip }>{ vmn.is_vip ? 'Yes' : 'No' }</td>
        <td title={ vmn.created_at || '-' }>{ vmn.created_at || '-' }</td>
        <td>
          <span style={ { display: vmn.is_reserved && !vmn.is_reserved_for_org ? '' : 'none' } } title="Move to available">
            <FontAwesomeIcon
              icon={ faSync }
              onClick={ (e) => {
                e.preventDefault();
                setMoveToAvailableModal(true);
                setVMNToMovetoAvailable(vmn);
                // showModalAndAssignService(service);
              } }
            />
          </span>
          <span style={ { display: vmn.is_used ? '' : 'none', marginLeft: '0.5em' } } title="Already Alloted">

            <a href="javascript:void(0)" alt="" className="icon pls">
              <FontAwesomeIcon
                icon={ faInfoCircle }
                onClick={ (e) => {
                  e.preventDefault();
                  // setShowModal(true);
                  // showModalAndAssignService(service);
                } }
              />
            </a>
          </span>
          <span style={ { display: !vmn.is_used ? '' : 'none' } }>
            <a href="javascript:void(0)" alt="" className="icon pls">
              <FontAwesomeIcon
                icon={ faTrashAlt }
                onClick={ (e) => {
                  e.preventDefault();
                  setShowModal(true);
                  setVMNToDelete(vmn);
                  // showModalAndAssignService(service);
                } }
              />
            </a>
          </span>
        </td>
      </tr>
    </>
  ));

  return (
    <div style={ {
      display: 'flex', padding: '1%', justifyContent: 'space-between', flexWrap: 'wrap', boxShadow: 'none',
    } }
    >
      <div>
        <h4 style={ { paddingRight: '2px' } }>
          Virtual Number List
          <a href="javascript:void(0)" style={ { paddingLeft: '5px' } } className="icon pls" uib-tooltip="Already allotted" ng-if="vmn.is_used">
            <FontAwesomeIcon
              icon={ faSync }
              onClick={ (e) => {
                e.preventDefault();
                getAllVMNS();
                // setShowModal(true);
                // showModalAndAssignService(service);
              } }
            />
          </a>
        </h4>
      </div>
      <div>
        <Button variant="danger" onClick={ () => { setStatsShowModal(true); } }>
          View Stats
        </Button>
        <OperationModal
          showFooter={ false }
          title="Stats"
          modalContent={ (
            <table className="table table-hover mb-table">
              <thead className="thead-dark">
                <tr>
                  <th>Category</th>
                  <th>Count</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Total(In table)</td>
                  <td title="{detail.totalVmnsTableCount}">{ detail.totalVmnsTableCount || 'NA' }</td>
                </tr>
                <tr>
                  <td>Total</td>
                  <td title="{detail.total_count}">
                    { detail.total_count || 'NA' }

                  </td>
                </tr>
                <tr>
                  <td>Available</td>
                  <td title="{detail.available_count}">{ detail.available_count || 'NA' }</td>
                </tr>
                <tr>
                  <td>Alloted</td>
                  <td title="{detail.used_count}">{ detail.used_count || 'NA' }</td>
                </tr>
                <tr>
                  <td>Reserved</td>
                  <td title="{detail.reserved_count}">{ detail.reserved_count || 'NA' }</td>
                </tr>
                <tr>
                  <td>Default</td>
                  <td title="{detail.default_count}">{ detail.default_count || 'NA' }</td>
                </tr>
                <tr>
                  <td>Premium</td>
                  <td title="{detail.premium_count}">{ detail.premium_count || 'NA' }</td>
                </tr>
                <tr>
                  <td>VIP</td>
                  <td title="{detail.vip_count}">{ detail.vip_count || 'NA' }</td>
                </tr>
              </tbody>
            </table>
          ) }
          show={ showStatsModal }
          failure={ () => setStatsShowModal(false) }
          onHide={ () => setStatsShowModal(false) }
        />

      </div>
      <div style={ { flexBasis: '100%' } }>
        <form className="form-horizontal">
          <div style={ { display: 'flex', paddingRight: '10%', margin: '1% 0%' } }>
            <div className="inputs-fl-1">
              <select className="form-control" id="search_category1" value={ formData.search_category1 } onChange={ onChange }>
                <option value="" selected="selected">All</option>
                <option value="premium">Premium</option>
                <option value="vip">VIP</option>
                <option value="reserved">Reserved</option>
              </select>
            </div>
            <div className="inputs-fl-1">
              <select
                className="form-control"
                id="search_category2"
                onChange={ onChange }
                value={ formData.search_category2 }
              >
                <option value="" selected="selected">Select Column</option>
                <option value="v_mobile_no">VMN</option>
                <option value="price_less">Price less than</option>
                <option value="price_greater">Price greater than</option>
                <option value="price_equal">Price equal to</option>
              </select>
            </div>
            <div className="inputs-fl-1">
              <select className="form-control" id="allotment_status" value={ formData.allotment_status } onChange={ onChange }>
                <option value="" selected="selected">Select Status</option>
                <option value="yes">Allotted</option>
                <option value="no">Not Allotted</option>
              </select>
            </div>
            <div className="inputs-fl-1">
              <input type="text" name="search" className="form-control" id="search_text" value={ formData.search_text } placeholder="Search by selected category" disabled={ !formData.search_category2 } onChange={ onChange } />
            </div>
            <div>
              <Button variant="danger" onClick={ getAllVMNS }>Search</Button>
            </div>
            <div />
          </div>
        </form>
        { isLoading ? <Spin />
          : (
            <>
              <div>
                <center>
                  <h4>
                    Total(Showing in table):
                    { detail.totalVmnsTableCount }
                  </h4>
                </center>
              </div>
              <div className="table-responsive bn">
                <table className="table">
                  <thead className="thad-dark">
                    <tr>
                      <th>Number</th>
                      <th>Price</th>
                      <th>Is Allotted</th>
                      <th>Is Premium</th>
                      <th>Is VIP</th>
                      <th>Created At</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    { vmnsHTML }
                    { error && <div style={ { color: 'red' } }>{ error }</div> }
                  </tbody>
                </table>

              </div>
            </>
          ) }
        <OperationModal
          show={ showModal }
          title="Delete VMN"
          success={ () => deleteVMN() }
          setShowModal={ setShowModal }
          modalContent="Are you sure want to delete the VMN?"
          onHide={ () => { setShowModal(false); } }
          failure={ () => { setShowModal(false); } }
        />
        ;
        <OperationModal
          show={ showMoveToAvailableModal }
          title="Move to Available"
          success={ () => moveToAvailable() }
          setShowModal={ setMoveToAvailableModal }
          modalContent={ `Do you want to move vmn ${vmnToMovetoAvailable.v_mobile_no} to available list?` }
          onHide={ () => { setMoveToAvailableModal(false); } }
          failure={ () => { setMoveToAvailableModal(false); } }
        />
      </div>
      <Pagination
        currentPage={ pageNo }
        totalPages={ Math.ceil((detail.totalVmnsTableCount || 0) / pageSize) || 1 }
        setPageNumber={ (page) => { setPageNumber(page); } }
      />
    </div>

  );
};
export default VMNSOverview;
